import { useEditor } from '@craftjs/core';
import { useCallback } from 'react';

import { UndoRedoButtonGroup } from '@/components/form/baseInputs/Button/UndoRedoButtonGroup';

export function UndoRedoButtons() {
  const { canUndo, canRedo, actions } = useEditor((_state, query) => ({
    canUndo: query.history.canUndo(),
    canRedo: query.history.canRedo(),
  }));

  const handleUndo = useCallback(() => {
    actions.history.undo();
  }, [actions]);

  const handleRedo = useCallback(() => {
    actions.history.redo();
  }, [actions]);

  return (
    <UndoRedoButtonGroup
      onUndo={handleUndo}
      onRedo={handleRedo}
      canUndo={canUndo}
      canRedo={canRedo}
    />
  );
}
